export var ModalKeys;
(function (ModalKeys) {
    ModalKeys["SHARE_TRIP"] = "share-trip";
    ModalKeys["INVITE_USERS"] = "invite-users";
    // Add more modal keys here
})(ModalKeys || (ModalKeys = {}));
